<template>
  <section class="pb-[60px] xl:pb-[140px]" id="affiliate-program">
    <div class="container">
      <div
        class="w-full flex-y-center lg:justify-between justify-center text-center lg:text-left gap-6 lg:flex-row flex-col relative gradient-bg p-8 lg:p-10 rounded-3xl overflow-hidden"
      >
        <div class="max-w-[550px] z-20">
          <h3
            class="text-xl lg:text-[28px] font-bold text-white leading-[32px]"
          >
            {{ $t("landing.affiliate_program.title") }}
          </h3>
          <p class="text-white text-base mt-1">
            {{ $t("landing.affiliate_program.description") }}
            Program, turning your network into a reliable source of passive
            income!
          </p>
        </div>
        <RouterLink to="/auth/register">
          <Button
            :text="$t('landing.affiliate_program.button')"
            variant="primary"
            size="md"
            class="relative z-20"
          />
        </RouterLink>
        <div
          class="absolute -top-12 right-[80%] lg:right-60 w-[130px] h-[130px]"
        >
          <img
            src="/landing/coins/bitcoin.png"
            alt="Bitcoin"
            class="w-full h-full object-contain"
          />
        </div>
        <div class="absolute -bottom-12 -right-10 w-[130px] h-[130px]">
          <img
            src="/landing/coins/ethereum.png"
            alt="Ethereum"
            class="w-full h-full object-contain"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Button from "@/modules/Landing/components/Base/Button/Button.vue";
</script>

<style scoped>
.gradient-bg {
  background: radial-gradient(
    41.92% 186.84% at 5.95% 49.69%,
    #0d5e36 0%,
    #114129 19%,
    #152b1f 39%,
    #171e19 59%,
    #181a18 76%
  );
}
</style>
